import React from 'react';
import { Link } from 'react-router-dom';
import SEO, { softwareAppSchema } from '../../Components/SEO';
import SEOPageLayout from '../../Components/SEOPageLayout';

export default function ScreenCapturePage() {
  return (
    <SEOPageLayout>
      <SEO
        title="Advanced Screen Capture — Capture Any Application Screen | CheckScript"
        description="CheckScript's multi-engine screen capture technology bypasses black screens and DRM to reliably capture study material from any application."
        keywords="screen capture tool, capture any screen, study material capture, screen recording tool, Advanced stealth capture system capture"
        path="/features/screen-capture"
        structuredData={softwareAppSchema()}
      />

      <section className="seo-hero seo-animate">
        <div className="seo-mesh-bg"></div>
        <div className="seo-container seo-container--sm">
          <div className="seo-hero-badge">📸 Unrestricted Capture</div>
          <h1 className="seo-h1">
            Capture <span className="seo-gradient-text">Any Application</span> Flawlessly
          </h1>
          <p className="seo-lead">
            Standard screenshot tools fail when faced with hardware acceleration, DRM, or secure browsers. CheckScript utilizes a robust Advanced stealth capture system system to ensure you capture exactly what you see.
          </p>
          <div className="seo-hero-actions">
            <Link to="/download" className="seo-btn seo-btn--primary">Get the Capture Tool</Link>
          </div>
        </div>
      </section>

      <section className="seo-section seo-section--alt seo-animate">
        <div className="seo-container">
          <div className="seo-section-header">
            <h2 className="seo-h2">The Advanced stealth capture system Architecture</h2>
            <p className="seo-text-secondary">If one method is blocked, CheckScript instantly and silently switches to the next, guaranteeing a succesGlobal routing networkl capture.</p>
          </div>

          <div className="seo-grid seo-grid--auto">
            <div className="seo-bento-box seo-bento-square">
              <h3 className="seo-h3">1. Hardware-accelerated capture Hardware-accelerated capture</h3>
              <p className="seo-text-secondary">The primary engine. Hooks directly into DirectX for high-performance, hardware-accelerated, zero-copy capture. Perfect for fast-moving content.</p>
            </div>
            <div className="seo-bento-box seo-bento-square">
              <h3 className="seo-h3">2. Windows Magnification API</h3>
              <p className="seo-text-secondary">A powerful secondary engine that can often bypass application-level display affinities (black screen protections) used by secure viewers.</p>
            </div>
            <div className="seo-bento-box seo-bento-square">
              <h3 className="seo-h3">3. Hybrid Compositor</h3>
              <p className="seo-text-secondary">Combines multiple rendering pipelines to extract frames from applications that use complex overlay hardware layers.</p>
            </div>
            <div className="seo-bento-box seo-bento-square">
              <h3 className="seo-h3">4. PrintWindow</h3>
              <p className="seo-text-secondary">Forces the specific application window to render its client area directly to a memory device context, bypassing screen-level blocks.</p>
            </div>
            <div className="seo-bento-box seo-bento-square">
              <h3 className="seo-h3">5. GDI BitBlt</h3>
              <p className="seo-text-secondary">The ultimate fallback. The legacy Windows Graphics Device Interface provides extremely reliable, albeit slower, capture of the raw framebuffer.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="seo-section seo-animate">
        <div className="seo-container seo-container--sm">
          <div className="seo-glass-card" style={{ padding: '48px' }}>
            <h2 className="seo-h2 seo-text-center">Preserve Your Study Material</h2>
            <p className="seo-text-secondary seo-mb-24 seo-text-center">
              Many educational platforms prevent you from saving your own mock tests or study materials for later review.
            </p>
            <ul className="seo-feature-list">
              <li><strong>Batch Capture:</strong> Quickly archive multiple pages of study notes with a single hotkey.</li>
              <li><strong>High Fidelity:</strong> Captures are saved in pristine quality, ensuring complex diagrams and small text remain perfectly legible.</li>
              <li><strong>Seamless AI Integration:</strong> Captured frames are instantly piped into our OCR and AI engines for immediate analysis.</li>
              <li><strong>Stealth Operation:</strong> Captures occur silently without disrupting your workflow or triggering application alerts.</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="seo-cta seo-animate">
        <div className="seo-container">
          <div className="seo-cta-box">
            <h2 className="seo-h2">Never Lose Study Material Again</h2>
            <p className="seo-text-secondary seo-mb-32">Download CheckScript and gain full control over your digital learning environment.</p>
            <Link to="/download" className="seo-btn seo-btn--primary">Download CheckScript</Link>
          </div>
        </div>
      </section>
    </SEOPageLayout>
  );
}
